/**
 * Convert any string to a URL-safe slug handle.
 * "La Roche-Posay" → "la-roche-posay"
 * "Face Wash"      → "face-wash"
 */
export const toHandle = (str) =>
  (str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
